// react and js
import { React } from "react";
import { Trans, useTranslation } from "react-i18next";

// mui
import { Typography, Link, Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

// i18n
import { localizeExternalUrl } from "../i18n/languages";

// components

// hooks

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function PublicFooter() {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const lang = i18n.language;
  const websiteUrl = localizeExternalUrl(process.env.REACT_APP_URL_FRONTEND_WEBSITE, lang);
  const imprintUrl = localizeExternalUrl(process.env.REACT_APP_URL_FRONTEND_IMPRINT, lang);
  const privacyPolicyUrl = localizeExternalUrl(process.env.REACT_APP_URL_FRONTEND_PRIVACY_POLICY, lang);
  const termsUrl = localizeExternalUrl(process.env.REACT_APP_URL_FRONTEND_TERMS_AND_CONDITIONS, lang);
  const riskDisclosureNoticeUrl = localizeExternalUrl(
    process.env.REACT_APP_URL_FRONTEND_RISK_DISCLOSURE_NOTICE,
    lang
  );
  return (
    <Box>
      <Box sx={{ textAlign: "center", mb: -0.5 }}>
        <Typography variant="footerPublic">
          <Trans i18nKey="layout.footer.recaptchaNotice">
            This site is protected by reCAPTCHA and the Google&nbsp;
            <Link
              variant="footerPublicLink"
              underline="none"
              color="inherit"
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener"
              sx={{ fontWeight: "bold" }}
            >
              Privacy Policy
            </Link>
            &nbsp;and&nbsp;
            <Link
              variant="footerPublicLink"
              underline="none"
              color="inherit"
              href="https://policies.google.com/terms"
              target="_blank"
              rel="noopener"
              sx={{ fontWeight: "bold" }}
            >
              Terms of Service
            </Link>
            &nbsp;apply.
          </Trans>
        </Typography>
      </Box>

      {isDesktop === true ? (
        <Box>
          <Typography variant="footerPublic">
            <Link
              variant="footerPublicLink"
              underline="none"
              color="inherit"
              href={websiteUrl}
            >
              © {new Date().getFullYear()} {process.env.REACT_APP_NAME_LEGAL}
            </Link>
            &nbsp;&bull;&nbsp;
            <Link
              variant="footerPublicLink"
              underline="none"
              color="inherit"
              href={imprintUrl}
            >
              {t("layout.footer.imprint")}
            </Link>
            &nbsp;&bull;&nbsp;
            <Link
              variant="footerPublicLink"
              underline="none"
              color="inherit"
              href={privacyPolicyUrl}
            >
              {t("layout.footer.privacyPolicy")}
            </Link>
            &nbsp;&bull;&nbsp;
            <Link
              variant="footerPublicLink"
              underline="none"
              color="inherit"
              href={termsUrl}
            >
              {t("layout.footer.termsAndConditions")}
            </Link>
            {riskDisclosureNoticeUrl && (
              <>
                &nbsp;&bull;&nbsp;
                <Link
                  variant="footerPublicLink"
                  underline="none"
                  color="inherit"
                  href={riskDisclosureNoticeUrl}
                >
                  {t("layout.footer.riskDisclosureNotice")}
                </Link>
              </>
            )}
          </Typography>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography variant="footerPublic">
              <Link
                variant="footerPublicLink"
                underline="none"
                color="inherit"
                href={websiteUrl}
              >
                © {new Date().getFullYear()} {process.env.REACT_APP_NAME_LEGAL}
              </Link>
              &nbsp;&bull;&nbsp;
              <Link
                variant="footerPublicLink"
                underline="none"
                color="inherit"
                href={imprintUrl}
              >
                {t("layout.footer.imprint")}
              </Link>
              &nbsp;&bull;&nbsp;
              <Link
                variant="footerPublicLink"
                underline="none"
                color="inherit"
                href={privacyPolicyUrl}
              >
                {t("layout.footer.privacyPolicy")}
              </Link>
            </Typography>
          </Box>

          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography variant="footerPublic">
              <Link
                variant="footerPublicLink"
                underline="none"
                color="inherit"
                href={termsUrl}
              >
                {t("layout.footer.termsAndConditions")}
              </Link>
              {riskDisclosureNoticeUrl && (
                <>
                  &nbsp;&bull;&nbsp;
                  <Link
                    variant="footerPublicLink"
                    underline="none"
                    color="inherit"
                    href={riskDisclosureNoticeUrl}
                  >
                    {t("layout.footer.riskDisclosureNotice")}
                  </Link>
                </>
              )}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
}
